import { type SpreadsheetDescriptor } from '~/_shared/types/map';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { mapInfoSpreadsheetsSelector } from '../mapInfo/mapInfo.selectors';

export const primarySpreadsheetRealSpreadsheetsSelector = createStateSelector(
  [mapInfoSpreadsheetsSelector],
  (mapInfoSpreadsheets) => getRealSpreadsheetsForPrimary(mapInfoSpreadsheets),
);

export const usePrimarySpreadsheetRealSpreadsheets = () => useSelector(primarySpreadsheetRealSpreadsheetsSelector);

const getRealSpreadsheetsForPrimary = (spreadsheets?: readonly SpreadsheetDescriptor[]) => {
  if (!spreadsheets) {
    return null;
  }

  const primarySpreadsheet = spreadsheets.find(item => item.isPrimary);

  return primarySpreadsheet?.realSpreadsheets?.map(realSpreadsheet => ({
    id: realSpreadsheet.realSpreadSheetId,
    addRowLink: realSpreadsheet.addRowLink,
  })) ?? null;
};
